import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon-search.svg'


const _hoisted_1 = { class: "jr-fixed jr-block jr-right-5 jr-top-33 jr-z-50 jr-shadow" }
const _hoisted_2 = ["id", "placeholder"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-absolute jr-p-1 jr-top-0 jr-bottom-0 jr-right-2 jr-my-auto",
  src: _imports_0,
  alt: "icon-search"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: _ctx.id,
      type: "text",
      class: "jr-w-full jr-py-3 jr-px-4 jr-rounded-lg focus:jr-outline-none",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
      placeholder: _ctx.placeholder
    }, null, 8, _hoisted_2), [
      [_vModelText, _ctx.keyword]
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search', _ctx.keyword)))
    }, _hoisted_4)
  ]))
}